import WidgetMapStore  from './WidgetMapStore';
import AnalyticsStore from './AnalyticsStore';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

/**
 * @link https://www.bezkoder.com/vuex-typescript-jwt-auth/
 */
export default new Vuex.Store({
  modules:{
    WidgetMapStore,
    AnalyticsStore
  }
});